import DocumentMeta from 'react-document-meta';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import { EthereumClient, modalConnectors, walletConnectProvider } from "@web3modal/ethereum";
import { configureChains, createClient, WagmiConfig } from "wagmi";
import { avalanche, avalancheFuji } from "wagmi/chains";
import config from "./config.json";

import './css/style.css';
import 'react-toastify/dist/ReactToastify.min.css';

import Home from "./pages/Home";
import Payments from "./pages/Payments";
import RequestLink from "./pages/RequestLink";

let chains = [];
if (config.DEV_MODE === true) {
  chains = [avalancheFuji];
} else {
  chains = [avalanche];
}

const web3ModalProjectId = "c4136c307f11421161cf02dcad00cb8c";

// Wagmi client
const { provider } = configureChains(chains, [
  walletConnectProvider({ projectId: web3ModalProjectId }),
]);
const wagmiClient = createClient({
  autoConnect: true,
  connectors: modalConnectors({ appName: "web3Modal", chains }),
  provider,
});

const ethereumClient = new EthereumClient(wagmiClient, chains);

const meta = {
  meta: {
    charset: 'utf-8',
    name: {
      keywords: 'crypto,web3,biofi,biometricfinancial,finnovant,USB,UniSafeBox,password manager'
    }
  }
};

function App() {

  return (
    <DocumentMeta {...meta}>
      <WagmiConfig client={wagmiClient}>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route index element={<Home />} />
              <Route path="payment" element={<Payments web3ModalProjectId={web3ModalProjectId} web3ModalEthereumClient={ethereumClient} />} />
              <Route path="requestLink" element={<RequestLink />} />
              <Route path="*" element={<Navigate replace to="/" />} />
            </Routes>
          </BrowserRouter>
        </div>
        <ToastContainer />
      </WagmiConfig>
    </DocumentMeta>
  );
}

export default App;
